var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"bottom"}},[_c('div',{staticClass:"bottom-overlay"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"bottom-title"},[_c('span',{staticClass:"bottom-title_main"},[_vm._v("Donatrix: ")]),_vm._v(" "+_vm._s(_vm.$t('bottom.title'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }